/* tslint:disable:max-line-length */
import { CloseOutlined, InfoCircleFilled } from '@ant-design/icons';
import { Button, Spinner } from '@mm/components';
import React, { useState } from 'react';
import { ReactComponent as SendGridIcon } from 'assets/sendgrid.svg';
import { ReactComponent as GoogleIcon } from 'assets/icons/google-colorful-icon.svg';
import { ReactComponent as MicrosoftIcon } from 'assets/icons/microsoft-colorful-icon.svg';
import styles from './ActivateEmailAccountModal.module.css';
import { useActivateEmailAccount } from './use-activate-email-account';
import { useModalActions } from '@mm/state/modules/modalsState/actions';

export const ActivateEmailAccountModal = () => {
  const [microsoftAccountPopup, setMicrosoftAccountPopup] =
    useState<Window | null>(null);

  const { connectEmailAccount } = useActivateEmailAccount(
    setMicrosoftAccountPopup,
  );
  const { closeModal } = useModalActions();

  return (
    <div className={styles.container}>
      <CloseOutlined
        className={styles.closeIcon}
        onClick={() => closeModal()}
      />
      <div className={styles.heading}>Connect Your Email Account</div>

      <div className={styles.hint}>
        <InfoCircleFilled />
        Email accounts ending with @gmail.com are limited to 5 emails per day.
      </div>

      <p className={styles.hintFollowUp}>
        We encourage you to link a business email, such as a Google workspace
        email account, which is not limited in this way.
      </p>

      <div className={styles.buttons}>
        <Button
          size="md"
          color="secondary-blue"
          css={{ container: styles.button }}
          onClick={() => connectEmailAccount('gmail')}
          leftIcon={<GoogleIcon />}
        >
          Connect with Google
        </Button>

        <Button
          size="md"
          color="secondary-blue"
          css={{ container: styles.button }}
          onClick={e => {
            e?.stopPropagation();
            connectEmailAccount('microsoft');
          }}
          leftIcon={
            microsoftAccountPopup ? <Spinner standalone /> : <MicrosoftIcon />
          }
          disabled={!!microsoftAccountPopup}
        >
          Connect with Microsoft
        </Button>
        <Button
          size="md"
          color="secondary-blue"
          onClick={() => {
            connectEmailAccount('sendgrid');
          }}
          leftIcon={<SendGridIcon />}
          css={{ container: styles.button }}
        >
          Connect with SendGrid
        </Button>
        <Button
          size="md"
          color="secondary-blue"
          onClick={e => {
            e?.stopPropagation();
            connectEmailAccount('custom');
          }}
          leftIcon={<div />}
          css={{ container: styles.button }}
        >
          Connect Manually
        </Button>
      </div>
    </div>
  );
};
